<div class="w-full h-full flex flex-col items-start justify-start">
    @if (showFeatureBanner) {
        <app-feature-banner class="w-full" (onDismissBanner)="onClickBannerDismissed()" />
    }
    @if (currentUser?.timeZone) {
        <fm-calendar-header [timezone]="currentUser?.timeZone" class="w-full" />
        @if (initialized) {
            <fm-calendar-days
                [days]="days"
                [timezone]="currentUser.timeZone"
                [timeFormat]="currentUser.settings.timeFormat"
                [sessionDuration]="sessionDuration"
                (updatedScrollbarWidth)="onReceiveScrollbarWidth($event)"
                class="h-[calc(100%_-_64px)] w-full overflow-hidden" />
        }
    }

    @if ((selectedSessionService.selectedSessions$ | async).length) {
        @let length = (selectedSessionService.selectedSessions$ | async).length;
        <div
            class="w-full h-[75px] border-t border-t-latte flex justify-between items-center p-4 gap-4 gb-white">
            <p-button
                (click)="onClickBookSessions()"
                [loading]="bookingInProgress"
                size="large"
                severity="primary"
                class="flex-1"
                styleClass="w-full"
                [label]="
                    'Book ' + (length || 0) + ' ' + ((length || 0) === 1 ? 'session' : 'sessions')
                " />
            <p-button
                [disabled]="bookingInProgress"
                (click)="onClickClearAll()"
                size="large"
                severity="primary"
                [outlined]="true"
                class="flex-1"
                styleClass="w-full"
                label="Clear All" />
        </div>
    }
</div>
